module.exports = __webpack_public_path__ + "static/media/clients-bg.6c119f41.svg";